<div class="row">
  <div class="col-sm-4">
    <div name="InstructionTitle">
      <div class="form-group">
        <label for="InstructionTitle"> Instruction Title</label>
        <input id="Txt_InstructionTitle" type="text" class="form-control" maxlength="25" autocomplete="off">
      </div>
    </div>
  </div>
  <div class="col-sm-4">
  </div>
  <div class="col-sm-4">
    <div class="d-flex justify-content-end align-content-center" style="padding-right:30px">
      <span id="spAddItems" class="btn btn-outline-info waves-effect waves-light Addbtn clsMargin" (click)="GetDataProofingEPTById()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
      <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" data-dismiss="modal" (click)="AddUpdateProofingInstruction()">Save</button>
      <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
      <!--<button type="button" id="btnDelete" (click)="Delete()" style="display:none">Delete</button>-->
    </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="spUpdateitem" (click)="GetDataProofingEPTById()" class=" above" style="display:none"></button>
        <div class="col-md-12">
          <div class="form-group tblRightsList fixTableHead">
            <table id="tblAddList" class="table table-head-fixed" style="overflow-y: scroll !important; ">
              <thead>
                <tr>
                  <th>#</th>
                  <!--<th>Instruction Title</th>-->
                  <th>Instruction</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
        <!--popup body-->
        <div class="modal" id="myModal" [style.display]="showInstructionsModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12" name="InstructionItem" id="Divmail">
                    <div class="form-group">
                      <label for="InstructionItem"> Instruction </label>
                      <textarea class="form-control" id="Txt_InstructionItem" autocomplete="off" rows="2"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{ModalButton}}" (click)="addTableProofingEPT()"> {{ModalButton}} </button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
